const state = {
    data: [],
    dataTelegram: [],
}

const mutations = {
    storeCustomers (state, payload) {
        state.data = payload
    },

    storeTelegramCustomers (state, payload) {
        state.dataTelegram = payload
    },
}

const actions = {}

const getters = {
    getCustomers: state => state.data,
    getTelegramCustomers: state => state.dataTelegram,
}

export default {
    state,
    mutations,
    actions,
    getters
}
